export const GTM_EVENTS = {
  purchase: "purchase",
  favoriteAdd: "favorite_add",
  favoriteCancel: "favorite_cancel",
  join: "completeingiok_join",
  login: "completeingiok_login",
  awakeJoin: "complete_join",
  awakeLogin: "complete_login",
} as const;

export type GtmEventName = typeof GTM_EVENTS[keyof typeof GTM_EVENTS];
type GtmValue = string | number;
type GtmDetails = Record<string, GtmValue | null | undefined>;

export interface GtmDataLayerEvent extends Record<string, unknown> {
  event: GtmEventName;
  sellerId: string;
  timestamp: string;
  userId?: string;
}

declare global {
  interface Window {
    dataLayer?: GtmDataLayerEvent[];
  }
}

const cleanId = (value: string | number | null | undefined) => value === null || value === undefined ? "" : String(value).trim();

export function pushGtmEvent(event: GtmEventName, sellerId: string | number, userId?: string | number | null, details: GtmDetails = {}) {
  if (typeof window === "undefined") return false;
  const cleanSellerId = cleanId(sellerId);
  if (!cleanSellerId) return false;

  const payload: GtmDataLayerEvent = {
    event,
    sellerId: cleanSellerId,
    timestamp: new Date().toISOString(),
  };
  const cleanUserId = cleanId(userId);
  if (cleanUserId) payload.userId = cleanUserId;

  for (const [key, value] of Object.entries(details)) {
    if (["event", "sellerId", "userId", "timestamp"].includes(key) || value === null || value === undefined || value === "") continue;
    if (typeof value === "number" && !Number.isFinite(value)) continue;
    payload[key] = value;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  return true;
}

interface PurchaseEvent {
  sellerId: string | number;
  userId: string | number;
  name: string;
  productNumber: number;
  unitPrice: number;
  count: number;
  image?: string;
}

export function pushPurchaseGtmEvent(data: PurchaseEvent) {
  const name = data.name.trim();
  if (!name || !Number.isFinite(data.productNumber) || !Number.isFinite(data.unitPrice) || !Number.isInteger(data.count) || data.count < 1) return false;
  return pushGtmEvent(GTM_EVENTS.purchase, data.sellerId, data.userId, {
    name,
    productNumber: data.productNumber,
    unitPrice: data.unitPrice,
    totalPrice: data.unitPrice * data.count,
    count: data.count,
    image: data.image,
  });
}

